@if (!showFallback()) {
  <img
    [src]="logoPath()"
    [alt]="logoAlt()"
    [ngClass]="logoClasses()"
    [ngStyle]="{
      width: logoWidth(),
      height: logoHeight(),
    }"
    [attr.role]="clickable() ? 'button' : null"
    [attr.tabindex]="clickable() ? tabIndex() : null"
    [attr.aria-label]="ariaLabel()"
    class="hx-logo__image"
    (error)="handleImageError($event)" />
} @else {
  <div
    [ngClass]="logoClasses()"
    [ngStyle]="{
      width: logoWidth(),
      height: logoHeight(),
    }"
    class="hx-logo__fallback"
    [attr.role]="clickable() ? 'button' : null"
    [attr.tabindex]="clickable() ? tabIndex() : null"
    [attr.aria-label]="ariaLabel() || logoAlt()">
    <span class="hx-logo__fallback-text">
      @if (type() === 'company') {
        CC
      } @else {
        {{ product()?.substring(0, 2).toUpperCase() }}
      }
    </span>
  </div>
}
